import { Component } from "react";
import BaseModal, { ModalActions, SaveButton, CancelButton } from "../../../../containers/UI/Modal/BaseModal";
import InputRow from "../../../configuration/Rows/InputRow/InputRow";
import axios from "../../../../axios";


class CustomerModal extends Component {

  state = {
    customer: {},
    hasChanges: false,
  }

  componentDidMount() {
    if (this.props.selectedCustomer) {
      this.setState({ customer: { ...this.props.selectedCustomer } })
    }
  }

  updateProperty(property, value) {
    let customer = { ...this.state.customer }
    customer[property] = value
    this.setState({ customer, hasChanges: true })
  }

  saveHandler = () => {
    // Error-checking
    let customer = this.state.customer

    if (!customer.name || customer.name.trim() === "") {
      return alert("Please enter a legal name.")
    }

    // Sync to the backend
    axios.post("/customers/update", customer)

    // Close the modal view
    this.props.closeModal()
  }

  render() {
    let createMode = !this.props.selectedCustomer
    let canSave = createMode ? this.state.hasChanges : true

    return (
      <BaseModal 
        isOpen={this.props.shouldShow} 
        onClose={this.props.closeModal}
        title={createMode ? "New customer" : "Edit customer"}
      >
        <InputRow
          title="Legal name"
          enabled
          ultrawide
          firstRow
          value={this.state.customer.name ?? ""}
          placeholder={"E.g. Siemens SAS"}
          onChange={(event) => this.updateProperty("name", event.target.value)}/>
        <InputRow
          title="Short name"
          enabled
          ultrawide
          value={this.state.customer.shortName ?? ""}
          placeholder={"E.g. Giga"}
          onChange={(event) => this.updateProperty("shortName", event.target.value)}/>
        <InputRow
          title="Representative"
          enabled
          ultrawide
          value={this.state.customer.representative ?? ""}
          placeholder={"Main contact"}
          onChange={(event) => this.updateProperty("representative", event.target.value)}/>
        <InputRow
          title="VAT number"
          enabled
          ultrawide
          value={this.state.customer.vatNumber ?? ""}
          placeholder={"E.g. NL123456789B01"}
          onChange={(event) => this.updateProperty("vatNumber", event.target.value)}/>
        <InputRow
          title="Peppol ID"
          enabled
          ultrawide
          value={this.state.customer.peppolId ?? ""}
          placeholder={"E.g. 0208:0792248488"}
          onChange={(event) => this.updateProperty("peppolId", event.target.value)}/>
        <InputRow
          title="Address line 1"
          enabled
          ultrawide
          value={this.state.customer.addressLine1 ?? ""}
          placeholder={"Street and number"}
          onChange={(event) => this.updateProperty("addressLine1", event.target.value)}/>
        <InputRow
          title="Address line 2"
          enabled
          ultrawide
          value={this.state.customer.addressLine2 ?? ""}
          placeholder={"Postal code and city"}
          onChange={(event) => this.updateProperty("addressLine2", event.target.value)}/>
        <InputRow
          title="Country"
          enabled
          ultrawide
          value={this.state.customer.country ?? ""}
          placeholder={"E.g. Netherlands"}
          onChange={(event) => this.updateProperty("country", event.target.value)}/>

        <ModalActions>
          <CancelButton onClick={this.props.closeModal}/>
          <SaveButton 
            onClick={this.saveHandler}
            disabled={!canSave}
          >
            {createMode ? "Create" : "Save"}
          </SaveButton>
        </ModalActions>
      </BaseModal>
    );
  }
}

export default CustomerModal;
